<div class="lp-collection-info-header">
  <div class="lp-collection-info-header__wrapper">
    <button
      tuiIconButton
      type="button"
      [appearance]="isDesktop ? 'secondary' : 'icon'"
      [size]="isDesktop ? 'l' : 'm'"
      iconStart="@tui.chevron-left"
      (click)="onClickBackButton()"
    ></button>

    <div class="title">
      <h1 class="text_line-2">{{ title }}</h1>
    </div>

    <div class="view-header__action-buttons">
      <lp-statistics-button
        *ngIf="allowCollectionStatisticsViewing && mode === 'view'"
        [routerLink]="'/loyalty/collections/statistics/' + id"
        [queryParams]="{ unionId }"
      ></lp-statistics-button>
    </div>
  </div>
</div>
